import { AddIcon, InfoIcon } from "@chakra-ui/icons";
import { Box, Button, Image, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ICollection } from "../../services/graphql/Collection";

export interface ICardCollectionsProps {
  dataCollection: ICollection;
}
export const CardCollections = (props: ICardCollectionsProps) => {
  const { dataCollection } = props;
  const navigate = useNavigate();
  return (
    <>
      <Box
        boxShadow="md"
        maxW="sm"
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        display={"flex"}
        flexDirection="column"
      >
        {dataCollection.url_image ? (
          <div style={{ height: "225px", width: "100%" }}>
            <Image
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
              src={dataCollection.url_image}
              alt={dataCollection.name}
            />
          </div>
        ) : null}
        <Box
          p="6"
          mt={"auto"}
          h={"100%"}
          display="flex"
          flexDirection={"column"}
        >
          <Box display="flex" alignItems="baseline">
            <Box
              color="gray.500"
              fontWeight="semibold"
              letterSpacing="wide"
              fontSize="xs"
              textTransform="uppercase"
              ml="2"
            ></Box>
          </Box>
          <Box
            mt="1"
            fontWeight="semibold"
            as="h4"
            lineHeight="tight"
            isTruncated
          >
            {dataCollection.name}
          </Box>

          <Box display="flex" alignItems="center" my={"3"}>
            <InfoIcon color="teal.500" />
            <Box as="span" ml="2" color="gray.600" fontSize="sm">
              {dataCollection.description}
            </Box>
          </Box>

          <Box display="flex" mt="auto" alignItems="center">
            <Link
              className="link-without-underline"
              href={`/collection/${dataCollection.id}`}
            >
              <Button
                w="100%"
                rightIcon={<AddIcon />}
                colorScheme="blue"
                variant="outline"
              >
                Ver colección
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};
